import { routerMiddleware } from "connected-react-router"
import { createBrowserHistory } from "history"
import { applyMiddleware, createStore } from "redux"
import { composeWithDevTools } from "redux-devtools-extension"
import thunk from "redux-thunk"
import { createRootReducer } from "./app.reducer"

const historyBaseName: string = "atlas"

export const history = createBrowserHistory({
  basename: historyBaseName
})

export const bosAtlasStore = createStore(
  createRootReducer(history),
  composeWithDevTools(applyMiddleware(routerMiddleware(history), thunk))
)
